import type { TValidatorValue } from './models';

export interface ICustomValidation {
    /** Сообщение об ошибке */
    message: string;
    /** Регулярное выражени для проверки */
    reg: string;
}

export const customValidation =
    (cfg: ICustomValidation[]) =>
    (value: TValidatorValue = '') =>
        cfg.reduce((acc: string | undefined, { message, reg }) => {
            if (!new RegExp(reg).test(value)) {
                acc = message;
            }

            return acc;
        }, undefined);
